export const REGEX = {
  ONLY_NUMBER: /^\d+$/,
  PHONE_NUMBER: /^0\d*$/,
  FLOAD_NUMBER: /^[0-9,]+$/,

  REPLACE_NUMBER: /[^0-9]/g,

  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,

  FULL_NAME: /^[a-zA-ZÀ-ỹ\s]+$/,
  ENGLISH_NUMBER: /^[a-zA-Z0-9\s]+$/,
  CURRENCY_FORMAT: /^\d{1,3}(\.\d{3})*$/,

  ONLY_LETTERS_AND_NUMBERS: /^[a-zA-Z0-9]+$/, // Chỉ cho phép chữ cái và số
  ONLY_LETTERS: /^[a-zA-Z\s]+$/, // Chỉ cho phép chữ cái
};
